
/* global $ mymuesli */

(function () {

    /**
     * A (responsive) SVG view-component. Initializes a (responsive) raphael paper. If responsive the container defines the measures.
     *
     * @see http://bertanguven.com/raphael-js-setsize-function/
     * @see http://demosthenes.info/blog/744/Make-SVG-Responsive
     * @see http://tympanus.net/codrops/2014/08/19/making-svgs-responsive-with-css/
     * @see http://www.smashingmagazine.com/2013/06/clown-car-technique-solving-for-adaptive-images-in-responsive-web-design/
     */
    class AbstractSVGComponent extends mymuesli.interface.components.AbstractComponent {

        /**
         * Initializes a responsive svg-paper.
         *
         * @param $element
         * @param responsive boolean Defines weather the element should be responsive or not.
         */
        constructor ($element, responsive = true) {
            super($element);

            // @FIXME: Integrate Spinner Concept
            const size = $element.width();
            this._paper = Raphael($element.attr('id'), size, size);

            /* Make it responsive. jQuery cannot be used here: http://bugs.jquery.com/ticket/11166 */
            if (responsive) {
                this._paper.setViewBox(0, 0, size, size);
                this._setPaperAttributes({
                    'preserveAspectRatio': 'xMinYMin meet',
                    'class': 'raphael-svg-content',
                    'height': '100%',
                    'width': '100%',
                    'shape-rendering': 'geometricPrecision',
                    'text-rendering': 'geometricPrecision',
                    'color-rendering': 'optimizeQuality'
                });
            }
        }

        /**
         * Set all responsive paper attributes.
         *
         * @param attributes The dictionary of attributes.
         * @private
         */
        _setPaperAttributes(attributes = {}) {
            const self = this;
            $.each(attributes, function (attributeName, attributeValue) {
                self._paper.canvas.setAttribute(attributeName, attributeValue);
            });
        }

    }

    /* Expose the class. */
    mymuesli.interface.components.AbstractSVGComponent = AbstractSVGComponent;

}) ();
